<div class="flex flex-col gap-4 w-full flex-1 min-h-0 h-full">
  <!-- Barre d'outils supérieure (Filtres de statut & Rafraîchissement) -->
  <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 shrink-0">
    <!-- Puces de filtrage -->
    <div class="flex items-center gap-2 flex-wrap">
      <button
        type="button"
        (click)="onFilterChange('all')"
        [class]="
          currentFilter() === 'all'
            ? 'bg-neutral-12 text-neutral-1 font-semibold shadow-xs'
            : 'bg-neutral-2 hover:bg-neutral-3 text-neutral-11 hover:text-neutral-12 border border-neutral-4'
        "
        class="px-3 py-1.5 rounded-full text-xs transition-all cursor-pointer"
      >
        Tous les rendez-vous ({{ allAppointments().length }})
      </button>

      <button
        type="button"
        (click)="onFilterChange('confirmed')"
        [class]="
          currentFilter() === 'confirmed'
            ? 'bg-jade-9 text-white font-semibold shadow-xs'
            : 'bg-neutral-2 hover:bg-neutral-3 text-neutral-11 hover:text-neutral-12 border border-neutral-4'
        "
        class="px-3 py-1.5 rounded-full text-xs transition-all cursor-pointer inline-flex items-center gap-1.5"
      >
        <span
          class="w-1.5 h-1.5 rounded-full bg-jade-9"
          [class.bg-white]="currentFilter() === 'confirmed'"
        ></span>
        <span>Confirmés ({{ confirmedAppointmentsCount() }})</span>
      </button>

      <button
        type="button"
        (click)="onFilterChange('proposed')"
        [class]="
          currentFilter() === 'proposed'
            ? 'bg-amber-9 text-white font-semibold shadow-xs'
            : 'bg-neutral-2 hover:bg-neutral-3 text-neutral-11 hover:text-neutral-12 border border-neutral-4'
        "
        class="px-3 py-1.5 rounded-full text-xs transition-all cursor-pointer inline-flex items-center gap-1.5"
      >
        <span
          class="w-1.5 h-1.5 rounded-full bg-amber-9"
          [class.bg-white]="currentFilter() === 'proposed'"
        ></span>
        <span>En attente ({{ proposedAppointmentsCount() }})</span>
      </button>

      <!-- Séparateur vertical -->
      <div class="h-4 w-px bg-neutral-4 hidden md:block mx-1"></div>

      <!-- Calques d'agenda superposables -->
      @for (source of calendarSources(); track source.id) {
        <button
          type="button"
          (click)="onToggleSource(source.id)"
          [class]="
            source.visible
              ? getSourceBadgeClass(source.category)
              : 'bg-neutral-2 hover:bg-neutral-3 text-neutral-10 hover:text-neutral-12 border border-neutral-4'
          "
          class="px-3 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer inline-flex items-center gap-1.5"
          [matTooltip]="source.visible ? 'Masquer ' + source.name : 'Afficher ' + source.name"
        >
          <span
            class="w-1.5 h-1.5 rounded-full shrink-0"
            [class]="source.visible ? 'bg-white' : getSourceDotColor(source.category)"
          ></span>
          <span>{{ source.name }}</span>
        </button>
      }
    </div>

    <!-- Rafraîchissement rapide -->
    <div class="flex items-center gap-2 self-end sm:self-auto">
      <button
        type="button"
        (click)="onRefresh()"
        matTooltip="Actualiser les rendez-vous"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-neutral-11 hover:text-neutral-12 bg-neutral-2 hover:bg-neutral-3 border border-neutral-4 rounded-lg transition-colors cursor-pointer"
      >
        <mat-icon class="!text-sm !w-3.5 !h-3.5 flex items-center justify-center">refresh</mat-icon>
        <span>Actualiser</span>
      </button>
    </div>
  </div>

  <!-- Composant de Calendrier Core Aura -->
  <aura-calendar
    class="flex flex-col flex-1 min-h-0 w-full h-full"
    [events]="allCalendarEvents()"
    [(sources)]="calendarSources"
    [(view)]="currentView"
    [(currentDate)]="currentDate"
    [isLoading]="appointmentsResource.isLoading()"
    emptyMessage="Vous n'avez aucun rendez-vous ou visite programmée pour cette période."
    (eventClick)="onEventClick($event)"
  />
</div>
